import React, { useCallback, } from 'react';
import { isEmpty, } from 'ramda';
import { useTheme, } from '@material-ui/core/styles';
import classNames from 'classnames';

import { repositories, } from 'api';
import { cleanMediaQuery, getSize, convertSizesToHtmlFormat, } from './utils';
import { BreakpointsOptions, } from './types';
import { utils, } from 'styles';

type Props = {
    images: repositories.products.CollectionTypes.ProductsImageType,
    redirectToProductDetails: () => void,
    type: repositories.products.CollectionTypes.ProductsProductItemType,
};

const borderStyles = { border: '1px solid #d1d6d6', };

const ProductsItemCover: React.FC<Props> = ({
    images,
    redirectToProductDetails,
    type,
}) => {
    if (isEmpty(images) || images.thumbnails.items.length === 0) {
        return null;
    }

    const cursorClasses = utils.makePointerStyles();
    const borderColor = utils.makeGenericStyles(borderStyles);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const theme = useTheme();
    const [ paths, ] = images.thumbnails.items;
    const [ basicImage, ] = paths.sizes;

    const breakpointsOptions = [
        {
            media: theme.breakpoints.down('md'),
            sizes: {
                [theme.breakpoints.down('md')]: '120px',
            },
        },
        {
            media: theme.breakpoints.up('lg'),
            sizes: {
                [theme.breakpoints.up('lg')]: '150px',
            },
        },
    ];

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const renderPictures = useCallback((breakpointOption: BreakpointsOptions, index: number) => {
        const { absolutePath, size, } = paths.sizes[index];
        const media = cleanMediaQuery(breakpointOption.media);
        const srcSetSize = getSize(size).height + 'w';
        const srcSet = `${absolutePath} ${srcSetSize}`;
        const sizes = convertSizesToHtmlFormat(breakpointOption.sizes);

        return (
            <source key={absolutePath}
                    media={media}
                    srcSet={srcSet}
                    sizes={sizes} />
        );
    }, [ paths, cleanMediaQuery, ]);

    const isBook = type === repositories.products.CollectionTypes.PRODUCTS_PRODUCT_ITEM_MAP.BOOK;

    return (
        <picture onClick={redirectToProductDetails}
                 className={cursorClasses.root}>
            {breakpointsOptions.map(renderPictures)}
            <img src={basicImage.absolutePath}
                 className={classNames({ [borderColor.root]: isBook, })}
                 alt="Okładka produktu" />
        </picture>
    );
};

export default ProductsItemCover;
